import React, { useEffect, useState } from "react";

const SHOW_AFTER_PX = 400;

export default function BackToTop() {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const onScroll = () => setVisible(window.scrollY > SHOW_AFTER_PX);
        onScroll();
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    if (!visible) return null;

    return (
        <button
            type="button"
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
            className="md:hidden fixed left-1/2 -translate-x-1/2 bottom-[calc(58px+env(safe-area-inset-bottom,0px))] z-50 flex items-center gap-1.5 whitespace-nowrap rounded-full bg-white text-black border border-gray-300 shadow-md pl-3 pr-4 py-2 text-xs font-medium"
            aria-label="Kthehu lart"
        >
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                <path d="M12 19V5" />
                <path d="M5 12l7-7 7 7" />
            </svg>
            Kthehu lart
        </button>
    );
}
